import axios from "axios";

export default {
  state: {
    center: null,
    zoom: null,
    newOffer: undefined,
    offerWoj: undefined,
    offerPowiat: undefined,
    offerGmina: undefined,
    offersFilters: [
      {
        attribute: "",
        operator: "==",
        value: "",
        mergeOperator: "OR"
      }
    ],
    offerMapView: undefined,
    process: undefined
  },
  actions: {
    copyCbre(ctx, id) {
      const url = `/offers/${id}/copy`;
      return axios
        .post(url)
        .then(r => {
          if (r) {
            return r;
          }
        })
        .catch(e => {
          return e;
        });
    },
    postNewOffer(ctx, payload) {
      const url = `/offers`;
      return axios
        .post(url, payload)
        .then(r => {
          if (r) {
            return r;
          }
        })
        .catch(e => {
          return e;
        });
    },
    editOffer(ctx, payload) {
      const url = `/offers/${payload.id}`;
      return axios
        .put(url, payload)
        .then(r => {
          if (r) {
            return r;
          }
        })
        .catch(e => {
          return e;
        });
    },
    getOffers(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get("/offers", {
            params: payload
          })
          .then(r => {
            let offers = [];
            for (let offer of r.data.offers) {
              offers.push(offer);
            }
            resolve(offers);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // eslint-disable-next-line
    getProjects(ctx) {
      return axios
        .get("/projects")
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    getUserProjects(ctx) {
      return axios
        .get("/projects?only_current_user=true")
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    getProjectOffers(ctx, payload) {
      return axios
        .get("/projects_offers", {
          params: payload
        })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    getUserLayerGeometry(ctx, id) {
      return axios
        .get(`/layers/${id}/geometry`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    /*
       getPRG(ctx, payload) {
         let url = `/prg/${payload.level}`;
         return axios.get(url, {
           params: payload.params
         }).then(r => {
           if (r) {
             return r;
           }
           return false;
         }).catch(err => {
           return err.response.data;
         });
       },*/
    deleteFeature(ctx, payload) {
      return axios
        .delete(`/layers/${payload.layerId}/geometry/${payload.featureId}`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error;
        });
    },
    deleteOffer(ctx, id) {
      return axios
        .delete(`/offers/${id}`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error;
        });
    },
    deleteProject(ctx, id) {
      return axios
        .delete(`/projects/${id}`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error;
        });
    },
    deleteProjectOffer(ctx, payload) {
      return axios
        .delete("/projects_offers", {
          params: payload
        })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    editProjectOffer(ctx, payload) {
      return axios({
        url: "/projects_offers",
        method: "put",
        params: payload
      })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },

    getOwners(ctx) {
      return axios
        .get("/owners")
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.reposnse.data.message;
        });
    },
    postOfferFromParcels(ctx, payload) {
      return axios.post("/offers/from_parcels", payload);
    },
    postProject(ctx, payload) {
      return axios
        .post("/projects", payload)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    postPublicOfferToCopy(ctx, id) {
      return axios
        .post(`/offers/${id}/copy`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    postUserLayerGeometry(ctx, payload) {
      const id = payload.id;
      delete payload.id;
      return axios
        .post(`/layers/${id}/geometry`, payload)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    createPPTX(ctx, payload) {
      return axios
        .get("/export/pptx", {
          params: payload
        })
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });
    },
    createXLSX(ctx, payload) {
      return axios
        .get("/export/xlsx", {
          params: payload,
          responseType: "blob"
        })
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });
    },
    getPPTX(ctx, id) {
      return axios
        .get(`/export/pptx/${id}`, {
          responseType: "arraybuffer"
        })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error;
        });
    },
    getWMSCapabilities(ctx, payload) {
      const url = `${process.env.VUE_APP_DIVI_BASE_URL}/wms_proxy/${payload}?request=GetCapabilities&service=WMS`;
      return axios.get(url).then(r => {
        if (r) {
          return r;
        } else {
          return false;
        }
      });
    },
    attachmentsEdit(ctx, payload) {
      let url = `/attachments/${payload.id}`;
      return axios
        .put(url, payload)
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });
    },
    commentsEdit(ctx, payload) {
      let url = `/comments/${payload.id}`;
      return axios
        .put(url, payload)
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });
    },
    getOffer(ctx, { id, params }) {
      return axios
        .get(`/offers/${id}`, { params })
        .then(r => {
          if (r.status === 200) {
            return r;
          }
          return false;
        })
        .catch(err => {
          return err.response.data;
        });
    },
    getOffersHistory(ctx, idx) {
      return axios
        .get("/offers/history", {
          params: { page_number: idx, rows_per_page: 10 }
        })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(e => {
          return e;
        });
    },
    getUnreadCount(ctx) {
      return axios
        .get("/offers/history/unread/count")
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(e => {
          return e;
        });
    },
    markAsReadAll(ctx) {
      return axios
        .post("/offers/history/unread/mark_as_read")
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(e => {
          return e;
        });
    },
    markAsReadSingle(ctx, id) {
      return axios
        .post(`/offers/history/${id}/mark_as_read`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(e => {
          return e;
        });
    }
  },
  mutations: {
    setCenter(state, center) {
      state.center = center;
    },
    setZoom(state, zoom) {
      state.zoom = zoom;
    },
    setNewOffer(state, newOffer) {
      state.newOffer = newOffer;
    },
    setOfferWoj(state, offerWoj) {
      state.offerWoj = offerWoj;
    },
    setOfferPowiat(state, offerPowiat) {
      state.offerPowiat = offerPowiat;
    },
    setOfferGmina(state, offerGmina) {
      state.offerGmina = offerGmina;
    },
    setOffersFilters(state, offersFilters) {
      state.offersFilters = offersFilters;
    },
    setOfferMapView(state, offerMapView) {
      state.offerMapView = offerMapView;
    },
    setProcess(state, process) {
      state.process = process;
    }
  },
  getters: {
    getCenter(state) {
      return state.center;
    },
    getZoom(state) {
      return state.zoom;
    },
    getNewOffer(state) {
      return state.newOffer;
    },
    getOfferWoj(state) {
      return state.offerWoj;
    },
    getOfferPowiat(state) {
      return state.offerPowiat;
    },
    getOfferGmina(state) {
      return state.offerGmina;
    },
    getOffersFilters(state) {
      return state.offersFilters;
    },
    getOfferMapView(state) {
      return state.offerMapView;
    },
    getProcess(state) {
      return state.process;
    }
  }
};
